import * as React from 'react';
import { connect } from 'react-redux';
import { FormControl } from 'react-bootstrap';

import { AuthCard } from '../../components/AuthCard';
import { Container } from '../../components/Container';
import { Form } from '../../components/Form';
import { Label, InputGroup, TextInput } from '../../components/Input';
import { Button } from '../../components/Button';
import { Link } from '../../components/Link';
import { Redirect } from '../../components/Redirect';

import { api } from '../../utils/api';
import { showMessage } from '../../actions/message';

interface Props {
  token: string;
  showMessage: typeof showMessage;
}

interface State {
  email: string;
  password: string;
  formValidated: boolean;
  fetching: boolean;
  success: boolean;
}

export class _SetPassword extends React.Component<Props, State> {
  state = {
    email: '',
    password: '',
    formValidated: false,
    fetching: false,
    success: false,
  };

  handleFieldChange = (field: 'email' | 'password') => (value: string) => {
    this.setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  setPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.currentTarget;
    const { showMessage } = this.props;

    if (!form.checkValidity()) {
      event.stopPropagation();

      this.setState({
        formValidated: true,
      });

      return;
    }

    try {
      const { email, password } = this.state;
      const { token } = this.props;

      this.setState({ fetching: true });

      await api.post(
        '/login/reset_password',
        {},
        {
          email,
          password,
          token,
        }
      );

      showMessage({
        message: 'Password modificata con successo!',
      });

      this.setState({ success: true });
    } catch {
      this.props.showMessage({
        message: 'Si è verificato un errore durante la tua richiesta',
        type: 'danger',
      });
    } finally {
      this.setState({ fetching: false });
    }
  };

  render() {
    const { email, password, formValidated, fetching, success } = this.state;

    if (success) {
      return <Redirect to={'/'} />;
    }

    return (
      <AuthCard>
        <Container>
          <Form
            onSubmit={this.setPassword}
            validated={formValidated}
            noValidate
            centered
          >
            <Label>Email</Label>
            <InputGroup>
              <TextInput
                type={'email'}
                label={'Email'}
                value={email}
                onTextChange={this.handleFieldChange('email')}
                required
              />
              <FormControl.Feedback type={'invalid'}>
                Inserisci una mail valida
              </FormControl.Feedback>
            </InputGroup>

            <Label>Password</Label>
            <InputGroup>
              <TextInput
                type={'password'}
                label={'Password'}
                value={password}
                onTextChange={this.handleFieldChange('password')}
                required
              />
              <FormControl.Feedback type={'invalid'}>
                Inserisci una password
              </FormControl.Feedback>
            </InputGroup>

            <Button type={'submit'} disabled={fetching} loading={fetching}>
              Imposta password
            </Button>

            <Link to={'/'}>Hai già una password? Clicca qui</Link>
          </Form>
        </Container>
      </AuthCard>
    );
  }
}

export const SetPassword = connect(null, { showMessage })(_SetPassword);
